// ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  // Get user data from localStorage
  const userData = localStorage.getItem("userData");
  
  if (!userData) {
    // If no user data, redirect to login
    return <Navigate to="/" replace />;
  }

  const user = JSON.parse(userData);
  const userRole = user.role;

  // If no roles specified, allow all authenticated users
  if (allowedRoles.length === 0) {
    return children;
  }

  // Check if user's role is in the allowed roles
  if (allowedRoles.includes(userRole)) {
    return children;
  }

  // If user doesn't have permission, show access denied page
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      textAlign: 'center',
      padding: '20px'
    }}>
      <div style={{
        maxWidth: '500px',
        padding: '40px',
        borderRadius: '8px',
        backgroundColor: '#fff',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <svg 
          width="80" 
          height="80" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="#dc3545" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          style={{ margin: '0 auto 20px' }}
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        <h2 style={{ color: '#dc3545', marginBottom: '15px' }}>Access Denied</h2>
        <p style={{ color: '#666', marginBottom: '25px', fontSize: '16px' }}>
          You don't have permission to access this page. 
          Please contact your administrator if you believe this is an error.
        </p>
        <button
          onClick={() => window.history.back()}
          style={{
            padding: '10px 30px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: '500'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
        >
          Go Back
        </button>
      </div>
    </div>
  );
};

export default ProtectedRoute;